<tc-document-add-card
        [docTypeOptions]="docTypeOptions"
        [selectedDocs]="selectedDocs"
        (closeModal)="closeModal($event)">
</tc-document-add-card>
